<template>
	<div class="save-container">
		<SaveArt :content-data="saveData" :content-lang="lang"/>
	</div>
</template>

<script>

import useStore from 'webmd-cms-store/src/store';
import SaveArt from './SaveArt.vue';

export default {
	data() {
		return {
			// msg: 'This is a vue Page',
		};
	},

	components: {
		SaveArt
	},

	props: {
		lang: {
			type: String,
			required: false,
			default: null
		},
		title: {
			type: String,
			required: false,
			default: null
		},
		url: {
			type: String,
			required: false,
			default: null
		},
		type: {
			type: String,
			required: false,
			default: null
		},
		item_id: {
			type: String,
			required: false,
			default: null
		}
	},
	computed: {
		/*
		 * RssData() {
		 *   return this.pageData
		 * },
		 */
	},
	methods: {},
	created() {
		this.store = useStore(this.$pinia);
		this.saveData = {
			type: this.type || (this.store.pagedata.omniture.s_business_reference === 'News' ? 'news' : 'content'),
			item_id: this.item_id || this.store.pagedata.omniture.s_asset_id,
			title: this.title || this.store.pagedata.meta.og_tags.title,
			url: this.url || this.store.pagedata.meta.canonicalurl
		}
	}
};
</script>

<style lang="scss">
.save-container {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 2.5rem;
  margin-bottom: 0.75rem;
  margin-left: 1.4375rem;
  cursor: pointer;

	&:hover {
		.auth-overlay-popup-holder {
			.bookmark-holder {
				.bookmark-icon {
					@media (min-width: 64rem) {
						background-color: #D2D9FF;
					}
				}
			}
		}
	}
  	.save-text {
		color: #1B1B1B;
		font-family: "Source Sans Pro", Arial, sans-serif;
		font-size: 0.875rem;
		font-weight: 400;
		letter-spacing: 0.6px;
		line-height: 1.4;
		margin-right: 5px;
		position: relative;
		display: flex;
		align-items: center;
	}
	.icon-save {
		width: 40px;
		height: 40px;
		cursor: pointer;
	}
	.auth-overlay-popup-holder {
		.bookmark-holder {
			.bookmark-icon {
				position: static;
				display: flex;
				justify-content: center;
				align-items: center;
				border-radius: 50%;
				background-color: white;
				@media (max-width: 767px) {
					right: 0;
				}
			}
			.saved {
				background-color: #D2D9FF;
			}
		}
	}
}

</style>
